<template>
  <v-app >
    

    <v-content  >
      <v-container grid-list-md style="min-height: 90vh">
        
        <v-row class="mt-5">
          <v-col sm="4" lg="3">
            <v-card shaped="">
              <v-img width="" src="img/portada.jpg"></v-img>
              <v-card-actions>
                <v-btn block color="" text="" :to="{name: 'episodes'}">Ver Ahora</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col>
            <v-card shaped="">
              <v-card-title>
                <h2 class="display-2">De Perro Callejero a Joe</h2>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
            <p>En un futuro no tan lejano el boxeo evolucionó en un tipo diferente de deporte de contacto, conocido como Megalo boxeo. ¿En qué consiste? Los boxeadores usan un equipo mecánico que potencia los ataques y los golpes. Entre esta nueva generación de peleadores está un huérfano sin nombre, que por eso se hace llamar Perro Callejero (Junk Dog). Al no ser parte de la ciudadanía y no tener identificación, se ve forzado a participar en peleas ilegales que están arregladas por su entrenador, Nanbu.

Perro Callejero está cansado de vender peleas. Quiere demostrar su valor, su talento como peleador. Un encuentro fortuito es el que le brinda esa oportunidad. de revertir su situación. El encuentro con Yukiko Shirato, presidenta de la compañía que organiza Megalonia —el torneo para encontrar al mejor megalo boxeador del mundo— y su guardaespaldas, Yuri, motivan a Perro Callejero a buscar entrar en Megalonia y construir un nombre legítimo, un verdadero nombre. La premisa de Megalo Box es la misma que Ashita no Joe: el boxeo es la herramienta que permite al protagonista superarse y superar sus demonios. Perro Callejero tiene que encontrar la manera de entrar a Megalonia, y recurre a una identificación falsa de ciudadano para poder ingresar en el ranking. Adopta el nombre de Joe y parte desde el punto más bajo para poder aspirar a la posibilidad de enfrentarse a Yuri, el megalo boxeador número uno del mundo.</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

      <v-card>
        <v-card-title>
            Dejanos tus opiniones1
        </v-card-title>
        <v-card-text>
          <div class="comments">
    <vue-disqus shortname="megaloboxlatino"></vue-disqus>
  </div>
        </v-card-text>
      </v-card>

      </v-container>

      <v-footer class="mx-auto">
      <p class="mx-auto">Megalobox 2019</p>
    </v-footer>
    </v-content>

    

    
  </v-app>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {
  },
}
</script>
